import { AGENT_FUNNEL_PROFILE_COMPLETENESS_GRADATIONS, AGENT_QUANTITY_STAGES, AgentQuantityStage, FUNNEL_OUTSIDE_STAGE_ORDER, } from '@/entities/funnel-heatmap';
export const AGENT_QUANTITY_STAGE_HEATMAP_LABELS = {
    [AgentQuantityStage.NONE]: 'пусто',
    [AgentQuantityStage.APPEAL]: 'обращения',
    [AgentQuantityStage.LEAD]: 'лид',
    [AgentQuantityStage.MEETING]: 'встречи',
    [AgentQuantityStage.BOOKING]: 'брони',
    [AgentQuantityStage.DEAL]: 'сделки',
};
export const FUNNEL_OUTSIDE_CELL_LABEL = 'Вне воронки';
export function isFunnelOutsideCell(quantityStageOrder) {
    return quantityStageOrder === FUNNEL_OUTSIDE_STAGE_ORDER;
}
export function stageLabel(order) {
    if (isFunnelOutsideCell(order))
        return FUNNEL_OUTSIDE_CELL_LABEL;
    const stage = AGENT_QUANTITY_STAGES[order] ?? AgentQuantityStage.NONE;
    return AGENT_QUANTITY_STAGE_HEATMAP_LABELS[stage];
}
export function formatDelta(delta) {
    if (delta == null || delta === 0)
        return null;
    return delta > 0 ? `+${delta}` : String(delta);
}
export function profileCompletenessGradationLabel(yBucket) {
    const idx = Math.min(Math.max(0, yBucket), AGENT_FUNNEL_PROFILE_COMPLETENESS_GRADATIONS.length - 1);
    return `${AGENT_FUNNEL_PROFILE_COMPLETENESS_GRADATIONS[idx]}%`;
}
export function smartisCapturedYAxisLabel(yBucket) {
    return yBucket >= 1 ? 'Захвачен' : 'Не захвачен';
}
export function tgBotAvailabilityYAxisLabel(yBucket) {
    return yBucket >= 1 ? 'Доступен' : 'Не доступен';
}
export function transitionCellLabel(quantityStageOrder, yBucket, qualityMonths, options) {
    if (isFunnelOutsideCell(quantityStageOrder))
        return FUNNEL_OUTSIDE_CELL_LABEL;
    if (options?.smartisCapturedAxis) {
        return `${stageLabel(quantityStageOrder)} · ${smartisCapturedYAxisLabel(yBucket)}`;
    }
    if (options?.tgBotAvailabilityAxis) {
        return `${stageLabel(quantityStageOrder)} · ${tgBotAvailabilityYAxisLabel(yBucket)}`;
    }
    if (options?.profileCompletenessGradationAxis) {
        return `${stageLabel(quantityStageOrder)} · ${profileCompletenessGradationLabel(yBucket)}`;
    }
    if (options?.socialCompletenessAxis) {
        return `${stageLabel(quantityStageOrder)} · ${profileCompletenessGradationLabel(yBucket)}`;
    }
    if (yBucket === 0 && qualityMonths != null) {
        return `${stageLabel(quantityStageOrder)} · ни разу за ${qualityMonths} мес.`;
    }
    if (yBucket === 0) {
        return `${stageLabel(quantityStageOrder)} · 0`;
    }
    return `${stageLabel(quantityStageOrder)} · ${yBucket}`;
}
/** Discrete density steps from @unity/ui-kit `--unity-heatmap-0…4`. */
export function heatmapDensityLevel(count, maxCount) {
    if (count <= 0 || maxCount <= 0)
        return 0;
    const t = Math.min(1, count / maxCount);
    return Math.max(1, Math.round(t * 4));
}
export function heatmapCellBackground(count, maxCount) {
    return `var(--unity-heatmap-${heatmapDensityLevel(count, maxCount)})`;
}
export function heatmapCellTextColor(count, maxCount) {
    const level = heatmapDensityLevel(count, maxCount);
    if (level === 0)
        return 'var(--unity-color-muted)';
    // Levels 1–2 stay on light purple; 3–4 need on-brand text.
    return level >= 3
        ? 'var(--unity-color-on-brand)'
        : 'var(--unity-color-text)';
}
